import {
  AsyncButton,
  ButtonResponsiveProps,
  getResponsiveButtonProps,
} from '@framework/ui';
import React, { useCallback, useMemo } from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import { IFormTransformOnSubmitFn } from '../IFormTransformOnSubmitFn';
import { useFormAugmentedContext } from '../augmented/FormAugmentedContext';

export interface IManagedSubmitButtonProps
  extends Omit<ButtonResponsiveProps, 'onClick'> {
  submitArgs?: any;
  transformOnSubmit?: IFormTransformOnSubmitFn;
  onValid?: () => void;
  onInvalid?: () => void;

  text?: React.ReactNode;
  // iconRight?: React.ReactNode;
  iconRightComponent?: React.ComponentType;
  iconRightAriaLabel?: string;
}

/**
 * Bottone che gestisce programmaticamente il submit del form
 * permettendo di chiamare una funzione specifica in caso di validità
 * o invalidità del form.
 */
export function ManagedSubmitButton(props: IManagedSubmitButtonProps) {
  const { onInvalid, onValid, transformOnSubmit, ...otherProps } = props;

  const isMobile = useBreakpoint(down('md'));
  const buttonResponsiveProps = useMemo(() => {
    return getResponsiveButtonProps(
      otherProps satisfies ButtonResponsiveProps,
      isMobile,
    );
  }, [otherProps, isMobile]);

  const augmented = useFormAugmentedContext();

  const handleSubmit = useCallback(
    async (e: React.MouseEvent<HTMLElement>) => {
      try {
        await augmented.submitForm.current?.(e, transformOnSubmit);
        onValid?.();
      } catch (error) {
        onInvalid?.();
      }
    },
    [augmented.submitForm, onInvalid, onValid, transformOnSubmit],
  );

  return <AsyncButton {...buttonResponsiveProps} onClick={handleSubmit} />;
}
